<ng-template #dropdownButtonTemplate>
  <ng-container *ngIf="isActive; else defaultButtonText">
    {{ appliedFilter.min.text }} - {{ appliedFilter.max.text }} m<sup>2</sup>
    {{ 'filters.livingSpace.label' | i18n }}
  </ng-container>
  <ng-template #defaultButtonText>
    {{ 'filters.livingSpace.label' | i18n }}
  </ng-template>
</ng-template>

<ng-template #dropdownContentTemplate>
  <lib-living-space-filter (update)="select($event)"></lib-living-space-filter>
</ng-template>

<ng-template #applyButtonTemplate let-close="close">
  <button class="filter-apply-button" (click)="applyChanges(); close()">
    {{ 'common.apply' | i18n }}
  </button>
</ng-template>

<app-filter-dropdown
  [preferredWidth]="271"
  [dropdownButtonTemplate]="dropdownButtonTemplate"
  [dropdownContentTemplate]="dropdownContentTemplate"
  [applyButtonTemplate]="applyButtonTemplate"
  [hasValue]="isActive"
  (clear)="reset()"
>
</app-filter-dropdown>
